import { setGlobalCssModule } from "reactstrap/lib/utils";
import classNames from "./styles";

export const prefix = "oui-";
export const classNameMappings = classNames.reduce((mapper, cls) => {
  mapper[cls] = prefix + cls;
  return mapper;
}, {});
setGlobalCssModule(classNameMappings);
